import { render, staticRenderFns } from "./MessageTemplateEdit.vue?vue&type=template&id=e03495cc&scoped=true"
import script from "./MessageTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./MessageTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./MessageTemplateEdit.vue?vue&type=style&index=0&id=e03495cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03495cc",
  null
  
)

export default component.exports